import { components, LoadingIndicatorProps } from 'react-select';
import { OptionType } from '..';

export default function CustomLoading(props: LoadingIndicatorProps<OptionType>) {
	return (
		<components.LoadingIndicator {...props}>
			<span>...</span>
		</components.LoadingIndicator>
	);
}